/**
 * 🔧 제조 배지 (2026-07-28, v2.015) — 제조로 만든/제조에 쓰인 물량을 화면에서 구분한다.
 *
 *   MfgKindBadge : 입출고내역·품목 이력의 [구분] 칸 보조 배지.
 *     입고 행 = 🔧제조 — 제조로 만들어 들어온 완제품 (사 온 게 아님)
 *     출고 행 = 🔧투입 — 제조에 원재료로 들어가서 빠짐 (판 게 아님)
 *   MfgItemBadge : 재고 표 품목명 옆 🔧 — 지금 현재고에 제조품이 섞여 있다는 표시.
 *     (재고가 다 나가면 배지도 사라진다 — '지금 재고의 성격' 기준, 2026-07-28 사용자 확정)
 *
 * 세 화면(입출고내역 탭·품목 이력 팝업 2종)이 같은 배지를 복제하면 한쪽만 고쳐지는
 * 사고가 나서 여기 한 벌로 모았다 (v2.011 '화면용 복제본' 교훈).
 */

/** [구분] 칸 보조 배지 — 입고/출고 배지 밑에 붙는다 (옆에 붙이면 1280 에서 칸이 넘친다 — 실측). */
export function MfgKindBadge({ kind, mfgNo }: { kind: '입고' | '출고'; mfgNo: string | null }) {
  const isIn = kind === '입고';
  return (
    <span
      className="inline-block px-1.5 py-0.5 rounded text-[11px] font-bold bg-indigo-100 text-indigo-700 whitespace-nowrap"
      title={
        (isIn
          ? '제조로 만들어 들어온 완제품입니다 (매입해 온 것이 아님).'
          : '제조에 원재료로 투입되어 빠진 것입니다 (납품·판매 아님).') +
        (mfgNo ? `\n제조번호: ${mfgNo}` : '')
      }
    >
      🔧{isIn ? '제조' : '투입'}
    </span>
  );
}

/**
 * [구분] 칸 전체 — 입고/출고 배지 + (제조 행이면) 🔧 배지를 세로로 쌓는다.
 * 입출고내역 탭·품목 이력 팝업 2종이 같은 마크업을 복제하지 않도록 한 벌로 묶었다.
 */
export function KindBadge({
  kind,
  mfg,
  mfgNo,
}: {
  kind: '입고' | '출고';
  mfg?: boolean;
  mfgNo?: string | null;
}) {
  const isIn = kind === '입고';
  return (
    <span className="inline-flex flex-col items-center gap-0.5">
      <span
        className={`inline-block px-2 py-0.5 rounded text-xs font-bold ${
          isIn ? 'bg-emerald-100 text-emerald-700' : 'bg-orange-100 text-orange-700'
        }`}
      >
        {kind}
      </span>
      {mfg && <MfgKindBadge kind={kind} mfgNo={mfgNo ?? null} />}
    </span>
  );
}

/** 재고 표 품목명 옆 🔧 — 현재고에 제조품(자체 조립 완제품)이 포함돼 있음. */
export function MfgItemBadge({ count }: { count: number }) {
  return (
    <span
      className="ml-1 text-xs cursor-help align-middle"
      title={`현재고에 제조로 만든 물량 ${count}개가 들어 있습니다 (자체 조립 완제품).`}
    >
      🔧
    </span>
  );
}
